import React from 'react';
import { Stack } from '@fluentui/react';

const NotFound = () => {
    return (
        <Stack horizontalAlign="center" verticalAlign="center" styles={{ root: { height: "60vh" } }}>
            <Stack horizontalAlign="center" tokens={{ childrenGap: 12 }}>
                <span style={{ fontSize: 48, fontWeight: 600, color: "#323130" }}>404</span>
                <span style={{ fontSize: 20, color: "#605e5c" }}>Page not found</span>
                <span style={{ fontSize: 14, color: "#a19f9d" }}>
                    The page you're looking for doesn't exist or has been moved.
                </span>
                <a href="/" style={{ fontSize: 14, marginTop: 8 }}>Go to home</a>
            </Stack>
        </Stack>
    );
};

export default React.memo(NotFound);
